import axios, { CostHeaderParamsType, createCostHeader } from '@/shared/axios';
import { BaseResponse } from '@/types/web.interface';

export async function getShadowban(check_info: string, options?: CostHeaderParamsType) {
  const res = await axios.post<BaseResponse<any>>(
    `/ins/shadowban/risk`,
    {
      check_info,
    },
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}
